import React from 'react';
import './CyberneticLoader.css';

const CyberneticLoader = ({ size = 80, message = "Cargando..." }) => {
  return (
    <div className="cybernetic-loader-container">
      <div className="cybernetic-flower" style={{ width: size, height: size }}>
        <svg viewBox="0 0 100 100" className="flower-svg">
          {/* Center circle */}
          <circle cx="50" cy="50" r="8" className="flower-center" />
          
          {/* Petals */}
          {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, index) => (
            <g key={index} transform={`rotate(${angle} 50 50)`}>
              <ellipse
                cx="50"
                cy="25"
                rx="8"
                ry="18"
                className="flower-petal"
                style={{ animationDelay: `${index * 0.1}s` }}
              />
            </g>
          ))}
          
          {/* Outer glow rings */}
          <circle cx="50" cy="50" r="35" className="glow-ring ring-1" />
          <circle cx="50" cy="50" r="40" className="glow-ring ring-2" />
        </svg>
      </div>
      {message && (
        <p className="loader-message">{message}</p>
      )}
    </div>
  );
};

export default CyberneticLoader;
